import gql from 'graphql-tag';
import { surveyFragment, surveyFragmentForContacts } from "./fragments";

/*
*
*/
export const surveys = gql`
  query surveys($where: SurveyWhereInput, $orderBy: SurveyOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    surveys(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${surveyFragment}
  }
`;

export const surveysForContacts = gql`
  query surveys($where: SurveyWhereInput, $orderBy: SurveyOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    surveys(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${surveyFragmentForContacts}
  }
`;
